module.exports = __webpack_public_path__ + "static/media/web_goshare_step1.641fc506.mp4";